import React from 'react';
import PairBreaker from './PairBreaker';
import './EggDetail.scss';
import { Egg, eggImages } from 'contexts/EggContext';
import { getLevelAndProgress, isEggMaxLevel } from './eggUtils';
import { useEggStageContext } from '../../contexts/EggStageContext';
import { Star } from 'components/Icons/Icons';
import cls from 'classnames';
import { DropdownAnchor } from '../Dropdown/DropdownAnchor';
import { EggSharing } from '../Sharing/ShareTargets';

export type EggDetailProps = Egg & {
  setFavoriteEgg: (gribbleTokenId: number, favoriteBefore: boolean) => void;
};

const EggDetail = (props: EggDetailProps) => {
  const { id, points, breakerSrc, paired, favorite = false, setFavoriteEgg } = props;
  const [isPairBreakerModalOpen, setIsPairBreakerModalOpen] = React.useState(false);
  const stage = useEggStageContext();
  const { level, progress, currentPoints } = getLevelAndProgress(points);

  const eggStatic = eggImages.staticFromPoints(points, stage);
  const eggWebm = eggImages.detailWebmFromPoints(props, stage);
  const eggMp4 = eggImages.detailMp4FromPoints(props, stage);

  return (
    <aside className="egg-detail-card">
      <div className="row">
        <div className="col mb-3 egg-detail-actions">
          <button
            className={cls('btn btn-secondary btn-sm favorite-button', {
              favorited: favorite,
            })}
            onClick={() => {
              setFavoriteEgg(id, favorite);
            }}
          >
            <Star />
          </button>
          <DropdownAnchor>
            <EggSharing egg={props} />
          </DropdownAnchor>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => {
              setIsPairBreakerModalOpen(true);
            }}
          >
            {paired ? `Unpair Breaker` : `Pair Breaker`}
          </button>
        </div>
      </div>
      <div className="egg-pic">
        <div className="egg-breaker-pair">
          <img
            className="egg-paired-breaker img-fluid rounded-circle"
            src={breakerSrc}
            alt="Paired Breaker"
          />
          <video
            className="egg-image"
            id="egg-detail-video"
            autoPlay
            loop
            muted
            controls={false}
            poster={eggStatic}
            key={eggWebm}
          >
            <source src={eggWebm} type="video/webm" />
            <source src={eggMp4} type="video/mp4" />
          </video>
        </div>
      </div>
      <div className="egg-details pt-3">
        <span className="egg-progress-level">
          Level <b>{level}</b>
        </span>
        {isEggMaxLevel(points) ? (
          <span className="egg-points">
            <b>4000</b> / 4000
          </span>
        ) : (
          <span className="egg-points">
            <b>{currentPoints}</b> / 1000
          </span>
        )}
      </div>
      {!isEggMaxLevel(points) && (
        <div className="egg-progress progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${progress * 100}%` }}
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
          ></div>
        </div>
      )}

      {isPairBreakerModalOpen && (
        <PairBreaker gribbleId={id} onClose={() => window.location.reload()} />
      )}
    </aside>
  );
};

export default EggDetail;
